import { cloneDeep } from 'lodash';
import moment from 'moment';
const r = () => (Math.random() + 1).toString(36).substring(7);

export default class SlotsMatcher {
  constructor(slots, trail, firstSlot, lastSlot) {
    this.slots = slots;
    this.trail = trail;
    this.firstSlot = firstSlot;
    this.lastSlot = lastSlot;

    this.grids = cloneDeep(trail.equipmentToTrail).map(x => ({
      equipmentToTrail: x,
      slots: JSON.parse(JSON.stringify(Array(x.equipment.count).fill({ orders: [] }).map((x, i) => ({ ...x, index: i + 1 })))),
      ordersId: [],
      orders: [],
    }));
  }

  _getMinutesSinceMidnight(timeString) {
    const startDay = moment().startOf('day');

    let orderStartTime = new Date(timeString);
    orderStartTime.setFullYear(startDay.year())
    orderStartTime.setMonth(startDay.month())
    orderStartTime.setDate(startDay.date())
    orderStartTime = moment(orderStartTime)

    const minutesSinceMidnight = orderStartTime.diff(startDay, 'minutes');
    return minutesSinceMidnight;
  }

  _calculatePositionOnGrid(order) {
    // minuty -> procenty -> pixele
    const beforeOffset = this.firstSlot.startTimeMinutes;
    // const afterOffset = this.lastSlot.endTimeMinutes;

    const minutesStart = this.firstSlot.startTimeMinutes - beforeOffset;
    const minutesEnd = this.lastSlot.endTimeMinutes - beforeOffset;
    const minutesDuringDay = minutesEnd - minutesStart;

    const orderMinutesStart = this._getMinutesSinceMidnight(order.timeStart) - beforeOffset;
    const orderMinutesEnd = this._getMinutesSinceMidnight(order.timeEnd) - beforeOffset;
    const orderMinutes = orderMinutesEnd - orderMinutesStart;

    // minutesDuringDay = 100% width
    // console.log(minutesStart, minutesEnd, minutesDuringDay);
    // console.log(orderMinutesStart, orderMinutesEnd, orderMinutes);

    // zmiana z minut na procenty
    const leftPercent = (orderMinutesStart * 100) / minutesDuringDay
    const rightPercent = (orderMinutesEnd * 100) / minutesDuringDay

    const row = window.document.querySelector('.og-row');
    if (!row) return {}
    
    // zmiana z procentow na pixele
    const totalWidth = row.offsetWidth;
    const leftPixels = Math.round(leftPercent / 100 * totalWidth);
    const rightPixels = Math.round(rightPercent / 100 * totalWidth);

    // console.log('---------------');
    // console.log('left: ', leftPixels);
    // console.log('right: ', rightPixels);

    return {
      left: leftPixels,
      right: rightPixels,
      width: rightPixels - leftPixels,
    }
  }

  _checkIfOrderCanBeAddedToSlot(order, slot) {
    let canBeAdded = true;
    const { left, right } = this._calculatePositionOnGrid(order);

    // if(order.id === 39) console.log(slot.orders, order);
    // if(order.id === 41) console.log(slot.orders, order);
    slot.orders.forEach(o => {
      if (
        (left > o.position.left && left < o.position.right) || 
        (left === o.position.left && right === o.position.right) || 
        (right > o.position.left && right < o.position.right)
      ) {
        canBeAdded = false;
      }
    });

    return canBeAdded;
  }

  _addOrderToSlots(slots, count, order) {
    // console.log('Dodawanie zamowienia: ', order);
    // console.log('Liczba: ', count);
    // console.log('Dostępne sloty: ', slots);
    let placedEquipment = 0;
  
    for (let i = 0; i < count; i++) {
      slots.forEach(slot => {
        // checking 
        const canBeAdded = this._checkIfOrderCanBeAddedToSlot(order, slot);

        if (canBeAdded && placedEquipment < count) {
          slot.orders.push({
            orderData: order,
            position: this._calculatePositionOnGrid(order),
            uuid: r(),
          });
          placedEquipment++;
        }
      });
    }
  }

  _addOrdersToGrid(grid, order) {
    if (grid.ordersId.includes(order.id)) return ;
  
    for (const equipmentToOrder of order.equipmentsToOrder) {
      if (equipmentToOrder.equipmentToTrail.id === grid.equipmentToTrail.id) {
        this._addOrderToSlots(grid.slots, equipmentToOrder.count, order)
      }
    }
    grid.ordersId.push(order.id);
    grid.orders.push(order);
  }

  _addOrderToEquipmentToTrail(equipmentToTrailId, order) {
    console.log(order, equipmentToTrailId)
    const index = this.grids.findIndex(x => x.equipmentToTrail.id === equipmentToTrailId);
    if (index > -1) {
      this._addOrdersToGrid(this.grids[index], order)
    } else {
      alert('Coś poszło nie tak z tworzeniem siatki zamówień.')
    }
  }

  match() {
    // match orders
    this.slots.forEach(slot => {
      slot.orders.forEach(order => {
        order.equipmentsToOrder.forEach(orderEq => {
          this._addOrderToEquipmentToTrail(orderEq.equipmentToTrail.id, order);
        })
      });
    });

    return this.grids;
  }
}
